import {
  getWorkspaceBatches,
  updateBatchRun as requestUpdateBatchRun,
  createBatchRun as requestCreateBatchRun,
  archiveAllBatchRuns
} from "@utils/aegean_api_handler";

export const GET_BATCHES_REQUEST = "GET_BATCHES_REQUEST";
export const GET_BATCHES_SUCCESS = "GET_BATCHES_SUCCESS";
export const GET_BATCHES_ERROR = "GET_BATCHES_ERROR";

export const CREATE_BATCH_REQUEST = "CREATE_BATCH_REQUEST";
export const CREATE_BATCH_SUCCESS = "CREATE_BATCH_SUCCESS";
export const CREATE_BATCH_ERROR = "CREATE_BATCH_ERROR";

export const UPDATE_BATCH_REQUEST = "UPDATE_BATCH_REQUEST";
export const UPDATE_BATCH_SUCCESS = "UPDATE_BATCH_SUCCESS";
export const UPDATE_BATCH_ERROR = "UPDATE_BATCH_ERROR";

export const ARCHIVE_BATCHES_REQUEST = "ARCHIVE_BATCHES_REQUEST";
export const ARCHIVE_BATCHES_SUCCESS = "ARCHIVE_BATCHES_SUCCESS";
export const ARCHIVE_BATCHES_ERROR = "ARCHIVE_BATCHES_ERROR";

export const fetchBatchRuns = workspace_id => async (dispatch) => {
  dispatch({
    type: GET_BATCHES_REQUEST,
    workspace_id
  });

  try {
    const batches = await getWorkspaceBatches(workspace_id);
    dispatch({
      type: GET_BATCHES_SUCCESS,
      workspace_id,
      data: batches
    });
    return batches;
  } catch (error) {
    dispatch({
      type: GET_BATCHES_ERROR,
      workspace_id,
      error
    });
    throw error;
  }
};

export const createBatchRun = batchData => (dispatch) => {
  dispatch({
    type: CREATE_BATCH_REQUEST,
    workspace_id: batchData.workspace_id
  });

  return requestCreateBatchRun(batchData)
    .then((result) => {
      dispatch({
        type: CREATE_BATCH_SUCCESS,
        data: result
      });
      return result;
    })
    .catch((error) => {
      dispatch({
        type: CREATE_BATCH_ERROR,
        workspace_id: batchData.workspace_id,
        error
      });
      throw error;
    });
};

export const updateBatchRun = (id, batchData) => (dispatch) => {
  dispatch({
    type: UPDATE_BATCH_REQUEST,
    workspace_id: batchData.workspace_id
  });

  return requestUpdateBatchRun(id, batchData)
    .then((result) => {
      dispatch({
        type: UPDATE_BATCH_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_BATCH_ERROR,
        workspace_id: batchData.workspace_id,
        error
      });
      throw error;
    });
};

export const archiveBatchRuns = (workspace_id, ids) => (dispatch) => {
  dispatch({
    type: ARCHIVE_BATCHES_REQUEST,
    workspace_id
  });

  return archiveAllBatchRuns(ids)
    .then((result) => {
      dispatch({
        type: ARCHIVE_BATCHES_SUCCESS,
        workspace_id,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: ARCHIVE_BATCHES_ERROR,
        workspace_id,
        error
      });
      throw error;
    });
};
